import React, { useEffect, useState } from 'react';
import { IViewerAPI, createViewer, ViewerEventsMap, EventEmitter } from 'viewer3d';
import { ViewerContext } from './ViewerContext';
import { IViewerProviderProps } from './types';

export function ViewerProvider({ children }: IViewerProviderProps) {
  const [viewer, setViewer] = useState<IViewerAPI & EventEmitter<ViewerEventsMap> | null>(null);
  const [canvasId, setCanvasId] = useState<string>('');

  useEffect(() => {
    if (canvasId.length) {
      const viewerInstance = createViewer(canvasId);
      setViewer(viewerInstance);

      return () => {
        viewerInstance.dispose();
        setViewer(null);
      };
    }

    return () => { };
  }, [canvasId]);

  return (
    <ViewerContext.Provider value={{ viewer: viewer, initialize: setCanvasId }}>
      {children}
    </ViewerContext.Provider>
  );
}
